import UdeskLocales from 'UdeskLocales';
import React, { FC, memo } from 'react';
import { Button, Space } from 'udesk-ui';
import { Wrapper, Content, Item, Index, Config, Remove, Add, Info } from './styledComponents';
import RuleItem, { TemplateProps as RuleItemProps } from './components/Item';
import { AddCircleFilled, IndeterminateCircleFilled, InformationOutlined } from '@udesk/icons';
import isNil from 'lodash/isNil';
import { SelectProps } from 'antd';

export interface TemplateProps {
    value?: RuleItemProps['value'][];
    onChange?: (v: TemplateProps['value']) => void;
    options?: SelectProps<number>['options'];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, options } = props;

    return (
        <Wrapper>
            <Content>
                <Info>
                    <Space>
                        <InformationOutlined />
                        <span>
                            {/* 设定源语言与目标语言的对应关系。请在质检语言设置完成后，再设置翻译规则 */}
                            {
                                UdeskLocales['current'].pages.qaLanguageSetting.translate.template
                                    .components.rules.index
                                    .setTheCorrespondenceBetweenTheSourceLanguageAndTheTargetLanguagePleaseSetTheTranslationRulesAfterTheQualityInspectionLanguageIsSet
                            }
                        </span>
                    </Space>
                </Info>

                {value?.map((v, index) => {
                    return (
                        <Item>
                            <Index title={index + 1}>
                                {/* 规则 */}
                                {UdeskLocales['current'].components.languageSetting.index.rules}
                                {index + 1}
                            </Index>

                            <Config>
                                <RuleItem
                                    value={v}
                                    onChange={(v) =>
                                        onChange?.(
                                            value.map((_v, idx) => {
                                                if (idx === index) {
                                                    return v;
                                                } else {
                                                    return _v;
                                                }
                                            })
                                        )
                                    }
                                    sourceDisabledList={value.reduce((pre, cur, idx) => {
                                        if (idx === index) {
                                            return pre;
                                        } else {
                                            return [...pre, ...(cur?.sourceLang || [])];
                                        }
                                    }, [] as number[])}
                                    targetDisabledList={value.reduce((pre, cur, idx) => {
                                        if (idx === index || isNil(cur?.targetLang)) {
                                            return pre;
                                        } else {
                                            return [...pre, cur?.targetLang as number];
                                        }
                                    }, [] as number[])}
                                    options={options}
                                />
                            </Config>

                            <Remove>
                                <Button
                                    icon={<IndeterminateCircleFilled />}
                                    type="link"
                                    onClick={() =>
                                        onChange?.(value.filter((_, idx) => idx !== index))
                                    }
                                >
                                    {/* 移除 */}
                                    {
                                        UdeskLocales['current'].components.languageSetting.index
                                            .remove
                                    }
                                </Button>
                            </Remove>
                        </Item>
                    );
                })}
            </Content>

            <Add>
                <Button
                    icon={<AddCircleFilled />}
                    type="link"
                    onClick={() => onChange?.([...(value || []), {}])}
                    style={{ padding: 0 }}
                >
                    {/* 新增翻译规则 */}
                    {
                        UdeskLocales['current'].pages.qaLanguageSetting.translate.template
                            .components.rules.index.newTranslationRule
                    }
                </Button>
            </Add>
        </Wrapper>
    );
});

export default Template;
